<section class="received-history-card" *transloco="let t; prefix: 'parts.modals'">
  <div class="received-history-card__header">
    <h3>{{ t('receivedParts.title') }}</h3>

    <div class="received-history-card__actions">
      <app-date-filter
        [filter]="modalDateFilter"
        [isButtonIntervalSelector]="false"
        [disabledIntervals]="disabledIntervals"
        [defaultInterval]="defaultInterval"
        [datePickerPlacement]="'top'"
        (filterChanged)="onDateFilterChange($event)">
      </app-date-filter>

      <button type="button" class="add-stock-btn" (click)="openAddStock()">
        {{ t('receivedParts.addStock') }}
      </button>
    </div>
  </div>

  <div class="received-history-table">
    <table class="table">
      <thead>
        <tr>
          <th>{{ t('receivedParts.columnDateReceived') }}</th>
          <th>{{ t('receivedParts.columnInvoiceNumber') }}</th>
          <th>{{ t('receivedParts.columnStockBefore') }}</th>
          <th>{{ t('receivedParts.columnReceivedQty') }}</th>
          <th>{{ t('receivedParts.columnUnitCost') }}</th>
          <th>{{ t('receivedParts.columnLeadTime') }}</th>
          <th>{{ t('receivedParts.columnSupplier') }}</th>
        </tr>
      </thead>
    </table>

    <div
      class="received-history-table__body"
      infiniteScroll
      [scrollWindow]="false"
      [infiniteScrollDistance]="1.5"
      [infiniteScrollThrottle]="150"
      (scrolled)="onScrollDown()">
      @if (isReceivedHistoryLoading) {
        <div class="state-container">
          <div class="spinner-border text-danger" role="status"></div>
        </div>
      } @else if (hasError) {
        <div class="state-container">
          <app-error-state></app-error-state>
        </div>
      } @else if (shouldShowReceivedEmptyState) {
        <div class="state-container">
          <app-empty-state></app-empty-state>
        </div>
      } @else {
        <table class="table body-table">
          <tbody>
            @for (item of receivedHistory; track trackByHistory($index, item)) {
              <tr>
                <td>{{ formatDate(item.dateReceived) }}</td>
                <td>{{ item.invoiceNumber || '-' }}</td>
                <td>{{ item.stockBefore ?? '-' }}</td>
                <td>{{ item.receivedQty ?? '-' }}</td>
                <td>{{ formatCost(item.unitCost) }}</td>
                <td>{{ item.leadTime !== null && item.leadTime !== undefined ? t('receivedParts.leadTimeDays', { count: item.leadTime }) : '-' }}</td>
                <td>{{ item.supplier || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>

        @if (isLoadingMore) {
          <div class="load-more-spinner">
            <span class="spinner-border text-danger" role="status"></span>
          </div>
        }
      }
    </div>
  </div>
</section>